export default __webpack_public_path__ + "static/media/filter.5b3a9502.svg";